export function renderCertificatePng({ name, score, total, pct, cobrand }) {
  const W = 1400, H = 990;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#fffdf8';
  ctx.fillRect(0, 0, W, H);

  ctx.strokeStyle = '#fb923c';
  ctx.lineWidth = 10;
  ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.lineWidth = 3;
  ctx.strokeRect(62, 62, W - 124, H - 124);

  ctx.fillStyle = '#fff7ed';
  ctx.fillRect(70, 70, W - 140, 100);

  ctx.textAlign = 'center';
  ctx.fillStyle = '#ea580c';
  ctx.font = '700 26px Verdana, sans-serif';
  ctx.fillText(cobrand.toUpperCase(), W / 2, 132);

  ctx.fillStyle = '#8a8070';
  ctx.font = '600 28px Verdana, sans-serif';
  ctx.fillText('Certificat de fin de parcours', W / 2, 250);

  ctx.fillStyle = '#241f18';
  ctx.font = '900 86px Georgia, serif';
  ctx.fillText('Mon premier départ', W / 2, 355);

  ctx.fillStyle = '#5a5245';
  ctx.font = '400 30px Verdana, sans-serif';
  ctx.fillText('Ce certificat est décerné à', W / 2, 450);

  ctx.fillStyle = '#241f18';
  ctx.font = '900 64px Georgia, serif';
  ctx.fillText(name, W / 2, 545);

  ctx.fillStyle = '#5a5245';
  ctx.font = '400 28px Verdana, sans-serif';
  ctx.fillText("pour avoir terminé l'évaluation finale du livret pédagogique", W / 2, 625);
  ctx.fillStyle = '#ea580c';
  ctx.font = '900 40px Verdana, sans-serif';
  ctx.fillText(`Score : ${score}/${total}  (${pct} %)`, W / 2, 690);

  const dateStr = new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  ctx.fillStyle = '#8a8070';
  ctx.font = '400 26px Verdana, sans-serif';
  ctx.fillText(`le ${dateStr}`, W / 2, 745);

  ctx.strokeStyle = '#fdba74';
  ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(W / 2 - 220, 800); ctx.lineTo(W / 2 - 60, 800); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(W / 2 + 60, 800); ctx.lineTo(W / 2 + 220, 800); ctx.stroke();
  ctx.fillStyle = '#f97316';
  ctx.beginPath(); ctx.arc(W / 2, 795, 26, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#fff';
  ctx.font = '900 30px Verdana, sans-serif';
  ctx.fillText('★', W / 2, 806);

  ctx.fillStyle = '#b5a98f';
  ctx.font = '400 19px Verdana, sans-serif';
  ctx.fillText("Attestation pédagogique délivrée par le livret « Mon premier départ ».", W / 2, 865);
  ctx.fillText("Elle ne constitue ni un titre de conduite, ni un examen officiel, et ne remplace pas la formation pratique encadrée.", W / 2, 897);

  return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), 'image/png'));
}
